import { EntityType } from '@depanneo/types'
import { get } from '@/shared/utils/api-utils'

// Universal function to get document count for any entity type
export const getDocumentsCount = async (
  entityId: string,
  entityType: EntityType
) => {
  return await get<{ count: number }>(
    `/documents/count?entityId=${entityId}&entityType=${entityType}`
  )
}
